import  { APIClient } from "../api";

export default class GenerativeIaEvaluationService extends APIClient {

    // constructor(props: any) {
    //     super(props);
    // }

    async GetExpandedSuggestion(SolicitationCommentAIAssistanceRequest: any) {
        const url = `${this.endpoint}/GenIa/AIAssistance/GetExpandedSuggestion`;

        return this.api({
            method: 'post',
            url,
            data: SolicitationCommentAIAssistanceRequest
        })
    }

    async GetExpandedSuggestionConclusion(SolicitationCommentAIAssistanceRequest: any) {
        const url = `${this.endpoint}/GenIa/AIAssistance/GetExpandedSuggestionConclusion`;

        return this.api({
            method: 'post',
            url,
            data: SolicitationCommentAIAssistanceRequest
        })
    }

    async SetCommentSummary(solicitationSumarizeRequest: any) {
        const url = `${this.endpoint}/GenIa/AIAssistance/SetCommentSummary`;

        return this.api({
            method: 'post',
            url,
            data: solicitationSumarizeRequest
        })
    }

    async GetGenerativeIaEvaluationList(idSolicitation: number) {
        const url = `${this.endpoint}/GenIa/GetGenerativeIaEvaluationList/${idSolicitation}`;

        return this.api({
            method: 'get',
            url,
            headers: { "Content-Type": "application/json" },
        });
    }

    async SetNewCommentSumary(item: any) {
        const url = `${this.endpoint}/GenIa/SetNewCommentSumary`;

        return this.api({
            method: 'post',
            url,
            headers: { "Content-Type": "application/json" },
            data: item
        });
    }

    async SetEditCommentSummary(item: any) {
        const url = `${this.endpoint}/GenIa/SetEditCommentSummary`;

        return this.api({
            method: 'post',
            url,
            headers: { "Content-Type": "application/json" },
            data: item
        });
    }

    async CheckAiConfig(idSolicitation: number) {
        const url = `${this.endpoint}/GenIa/CheckAiConfig/${idSolicitation}`;

        return this.api({
            method: 'get',
            url,
            headers: { "Content-Type": "application/json" },
        });
    } 
}